import axios from "axios";

// Check if running as PWA
export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

// Check if mobile device
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         window.innerWidth < 768;
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Logo URL
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_func-spec-app/artifacts/r6gt7dan_DMe%20Logo.jpg";

// Send the httpOnly auth cookie with every request
axios.defaults.withCredentials = true;
